<template>
  <div class="modal fade show" :class="{active: active}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">
            <h5 class="modal-title">{{header}}</h5>
          </slot>
          <button type="button" class="close" @click="$dispatch('cancel')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot>
            {{content}}
          </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <div v-if="footer">
              {{footer}}
            </div>
            <div v-else>
              <button type="button" class="btn btn-secondary" @click="$dispatch('cancel')">{{cancel}}</button>
              <button type="button" class="btn btn-primary" @click="$dispatch('confirm')">{{confirm}}</button>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default{
    props:{
      header: String,
      footer: String,
      content: String,
      confirm: {type: String, default: 'Ok'},
      cancel: {type: String, default: 'Cancel'},
      active: {type: Boolean, default: false}
    }
  }
</script>
<style scoped>
  .active {
    background: rgba(0,0,0,.6);
    display:block;
  }

  .modal-body {
	  max-height: 79vh;
	  overflow-y: auto;
  }
</style>
